<div class="app-dialog">
  <header class="app-dialog__header">
    <div class="app-dialog__header-text">
      <h2>
        {{
          (isEditMode ? 'branchSettings.editHeader' : 'branchSettings.newHeader')
            | translate
        }}
      </h2>
    </div>
    <button mat-icon-button type="button" (click)="close()" [attr.aria-label]="'cancel' | translate">
      <mat-icon>close</mat-icon>
    </button>
  </header>

  <div class="app-dialog__body">
    <form [formGroup]="form" (ngSubmit)="submit()" class="branch-edit-dialog__form">
      <section class="app-dialog__section">
        <header class="app-dialog__section-head">
          <h3>{{ 'branchSettings.branchName' | translate }}</h3>
        </header>
        <div class="branch-edit-dialog__fields-grid">
          <mat-form-field appearance="outline" class="branch-edit-dialog__full-width">
            <mat-label>{{ 'branchSettings.name' | translate }}</mat-label>
            <input matInput formControlName="name" type="text" [errorStateMatcher]="errorStateMatcher" />
            <mat-error *ngIf="form.hasError('required', ['name'])">
              {{ 'fieldRequired' | translate }}
            </mat-error>
          </mat-form-field>
        </div>
      </section>

      <section class="app-dialog__section">
        <header class="app-dialog__section-head app-dialog__section-head--row">
          <h3>{{ 'branchSettings.variables' | translate }}</h3>
          <button
            mat-flat-button
            type="button"
            color="primary"
            class="branch-edit-dialog__add-button"
            (click)="addCustomVariable()"
          >
            <mat-icon>add</mat-icon>
            {{ 'settings.new' | translate }}
          </button>
        </header>

        <div
          class="branch-edit-dialog__variables-table"
          *ngIf="variablesFormArray.length > 0"
        >
          <table
            mat-table
            [dataSource]="variablesDataSource"
            class="mat-elevation-z0"
          >
            <ng-container matColumnDef="customField">
              <th mat-header-cell *matHeaderCellDef>
                {{ 'settings.customField' | translate }}
              </th>
              <td mat-cell *matCellDef="let control">
                {{ control.value.name }}
              </td>
            </ng-container>

            <ng-container matColumnDef="customLabel">
              <th mat-header-cell *matHeaderCellDef>
                {{ 'settings.customLabel' | translate }}
              </th>
              <td mat-cell *matCellDef="let control">
                <mat-form-field appearance="outline">
                  <input
                    matInput
                    [formControl]="control.get('label')"
                    type="text"
                  />
                </mat-form-field>
              </td>
            </ng-container>

            <ng-container matColumnDef="mandatory">
              <th mat-header-cell *matHeaderCellDef>
                {{ 'settings.mandatory' | translate }}
              </th>
              <td mat-cell *matCellDef="let control">
                <mat-checkbox
                  [formControl]="control.get('mandatory')"
                  color="primary"
                ></mat-checkbox>
              </td>
            </ng-container>

            <ng-container matColumnDef="overridable">
              <th mat-header-cell *matHeaderCellDef>
                {{ 'settings.overridable' | translate }}
              </th>
              <td mat-cell *matCellDef="let control">
                <mat-checkbox
                  [formControl]="control.get('overridable')"
                  color="primary"
                ></mat-checkbox>
              </td>
            </ng-container>

            <ng-container matColumnDef="defaultValue">
              <th mat-header-cell *matHeaderCellDef>
                {{ 'settings.defaultValue' | translate }}
              </th>
              <td mat-cell *matCellDef="let control">
                <div
                  *ngIf="isBranchCountryVariable(control.value.name); else defaultValueInput"
                  class="branch-edit-dialog__country-field"
                >
                  <app-country-select
                    [formControl]="control.get('defaultValue')"
                  ></app-country-select>
                </div>
                <ng-template #defaultValueInput>
                  <mat-form-field appearance="outline">
                    <input
                      matInput
                      [formControl]="control.get('defaultValue')"
                      type="text"
                    />
                  </mat-form-field>
                </ng-template>
              </td>
            </ng-container>

                        <ng-container matColumnDef="icon">
              <th mat-header-cell *matHeaderCellDef>
                <span class="header-cell-inner">
                  {{ 'settings.variableIcon' | translate }}
                  <mat-icon
                    class="header-help"
                    [matTooltip]="'settings.variableIconHint' | translate"
                    matTooltipPosition="above"
                    [attr.aria-label]="'settings.variableIconHint' | translate"
                    >help_outline</mat-icon
                  >
                </span>
              </th>
              <td mat-cell *matCellDef="let control">
                <mat-form-field
                  appearance="outline"
                  class="branch-edit-dialog__variable-icon-field icon-select-field"
                >
                  <mat-select
                    [formControl]="control.get('iconUrl')"
                    [disabled]="mediaImagesLoading"
                  >
                    <mat-select-trigger>
                      <span class="branch-edit-dialog__icon-trigger">
                        @if (
                          mediaFilePreview(control.get("iconUrl")?.value);
                          as preview
                        ) {
                          <span
                            class="branch-edit-dialog__icon-file"
                            aria-hidden="true"
                          >
                            <mat-icon>{{ preview.icon }}</mat-icon>
                            <span>{{ preview.label }}</span>
                          </span>
                        } @else {
                          <img
                            [src]="iconSrc(control.get('iconUrl')?.value)"
                            alt=""
                            class="branch-edit-dialog__icon-trigger-img"
                            width="22"
                            height="22"
                            loading="lazy"
                          />
                        }
                        {{ iconLabel(control.get("iconUrl")?.value) }}
                      </span>
                    </mat-select-trigger>
                    <mat-option
                      *ngIf="isUnknownIconUrl(control.get('iconUrl')?.value)"
                      [value]="control.get('iconUrl')?.value"
                    >
                      <span class="branch-edit-dialog__icon-option">
                        @if (
                          mediaFilePreview(control.get("iconUrl")?.value);
                          as preview
                        ) {
                          <span
                            class="branch-edit-dialog__icon-file"
                            aria-hidden="true"
                          >
                            <mat-icon>{{ preview.icon }}</mat-icon>
                            <span>{{ preview.label }}</span>
                          </span>
                        } @else {
                          <img
                            [src]="iconSrc(control.get('iconUrl')?.value)"
                            alt=""
                            class="branch-edit-dialog__icon-option-img"
                            width="28"
                            height="28"
                          />
                        }
                        <span>{{
                          iconLabel(control.get("iconUrl")?.value)
                        }}</span>
                      </span>
                    </mat-option>
                    <mat-option
                      *ngFor="let icon of hardcodedIcons"
                      [value]="icon.value"
                    >
                      <span class="branch-edit-dialog__icon-option">
                        <img
                          [src]="icon.preview"
                          alt=""
                          class="branch-edit-dialog__icon-option-img"
                          width="28"
                          height="28"
                        />
                        <span>{{ icon.label }}</span>
                      </span>
                    </mat-option>
                    <mat-option
                      *ngFor="let image of mediaImages"
                      [value]="image.imageUrl"
                    >
                      <span class="branch-edit-dialog__icon-option">
                        @if (mediaFilePreview(image.imageUrl); as preview) {
                          <span
                            class="branch-edit-dialog__icon-file"
                            aria-hidden="true"
                          >
                            <mat-icon>{{ preview.icon }}</mat-icon>
                            <span>{{ preview.label }}</span>
                          </span>
                        } @else {
                          <img
                            [src]="image.imageUrl"
                            alt=""
                            class="branch-edit-dialog__icon-option-img"
                            width="28"
                            height="28"
                          />
                        }
                        <span>{{ image.name }}</span>
                      </span>
                    </mat-option>
                  </mat-select>
                </mat-form-field>
              </td>
            </ng-container>

            <ng-container matColumnDef="actions">
              <th mat-header-cell *matHeaderCellDef>
                {{ 'settings.actionsColumn' | translate }}
              </th>
              <td mat-cell *matCellDef="let control; let rowIndex = index">
                <div class="table-actions" *ngIf="!isPredefinedVariable(control.value.name)">
                  <button
                    type="button"
                    class="action-btn action-btn--icon action-btn--danger"
                    [matTooltip]="'settings.removeRow' | translate"
                    [attr.aria-label]="'settings.removeRow' | translate"
                    (click)="removeVariable(rowIndex)"
                  >
                    <mat-icon>delete_outline</mat-icon>
                  </button>
                </div>
              </td>
            </ng-container>

            <tr
              mat-header-row
              *matHeaderRowDef="variableDisplayedColumns"
            ></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: variableDisplayedColumns"
              [formGroup]="row"
            ></tr>
          </table>

          <div class="branch-edit-dialog__loading" *ngIf="isLoadingVariables">
            <app-loading></app-loading>
          </div>
        </div>
      </section>

      <section class="app-dialog__section">
        <header class="app-dialog__section-head">
          <h3>{{ 'branchSettings.assignEmployees' | translate }}</h3>
        </header>

        <mat-form-field appearance="outline" class="branch-edit-dialog__search-field">
          <input
            matInput
            [formControl]="searchControl"
            [placeholder]="'employee.searchPlaceholder' | translate"
            [attr.aria-label]="'employee.search' | translate"
          />
          <mat-icon matPrefix>search</mat-icon>
        </mat-form-field>

        <div class="branch-edit-dialog__employee-table">
          <table mat-table [dataSource]="filteredEmployees">
            <ng-container matColumnDef="select">
              <th mat-header-cell *matHeaderCellDef>
                <mat-checkbox
                  (change)="$event ? masterToggle() : null"
                  [checked]="isAllSelected()"
                  [indeterminate]="
                    !isAllSelected() && selectedEmployees.length > 0
                  "
                >
                </mat-checkbox>
              </th>
              <td mat-cell *matCellDef="let employee">
                <mat-checkbox
                  (click)="$event.stopPropagation()"
                  (change)="$event ? toggleEmployeeSelection(employee) : null"
                  [checked]="isEmployeeSelected(employee)"
                >
                </mat-checkbox>
              </td>
            </ng-container>

            <ng-container matColumnDef="fullName">
              <th mat-header-cell *matHeaderCellDef>
                {{ 'employee.fullName' | translate }}
              </th>
              <td mat-cell *matCellDef="let employee">
                {{ employee.fullName }}
              </td>
            </ng-container>

            <ng-container matColumnDef="email">
              <th mat-header-cell *matHeaderCellDef>
                {{ 'employee.email' | translate }}
              </th>
              <td mat-cell *matCellDef="let employee">
                {{ employee.email }}
              </td>
            </ng-container>

            <tr
              mat-header-row
              *matHeaderRowDef="['select', 'fullName', 'email']"
            ></tr>
            <tr
              mat-row
              *matRowDef="let row; columns: ['select', 'fullName', 'email']"
              (click)="toggleEmployeeSelection(row)"
            ></tr>
          </table>

          <div class="branch-edit-dialog__loading" *ngIf="isLoadingEmployees">
            <app-loading></app-loading>
          </div>

          <div
            class="branch-edit-dialog__no-employees"
            *ngIf="!isLoadingEmployees && filteredEmployees.length === 0"
          >
            <p>{{ 'branchSettings.noEmployeesFound' | translate }}</p>
          </div>
        </div>

        <div
          class="branch-edit-dialog__selected-count"
          *ngIf="selectedEmployees.length > 0"
        >
          {{ 'branchSettings.selectedEmployees' | translate }}:
          {{ selectedEmployees.length }}
        </div>
      </section>
    </form>
  </div>

  <footer class="app-dialog__footer">
    <button mat-stroked-button type="button" (click)="close()">{{ 'cancel' | translate }}</button>
    <button
      mat-raised-button
      color="primary"
      type="button"
      (click)="submit()"
      [disabled]="sendingRequest || !form.dirty"
    >
      <mat-spinner *ngIf="sendingRequest" diameter="20" class="dc-btn-spinner"></mat-spinner>
      {{ (sendingRequest ? 'saving' : 'save') | translate }}
    </button>
  </footer>
</div>
